import axios from '../api/axios';
import useAuth from './useAuth';
import Cookies from 'js-cookie';
import useUserStuff from "./useUserStuff";

const useRefreshToken = () => {
    const { setAuth, auth } = useAuth();
    const {userStuff} = useUserStuff();
    // console.log(`auth: ${JSON.stringify(auth)}`);
    const refresh = async () => {
        const response = await axios.get('/auth/refresh', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('refreshToken')||userStuff?.refreshToken||Cookies.get('refreshToken')} `
            },
            withCredentials: true
        });
        console.log(localStorage.getItem('refreshToken')||userStuff?.refreshToken||Cookies.get('refreshToken'))
        setAuth(prev => {
            return {
                ...prev,
                roles: response.data.roles,
                accessToken: response.data.accessToken,
                userId: response.data.userId
            }
        });
        localStorage.setItem('refreshToken', response.data.refreshToken)
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;
